import { AddIcon } from '@chakra-ui/icons';
import { HStack } from '@chakra-ui/react';
import { useCallback, useMemo, useRef, useState } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';

import useGetCarriers from './queries/useGetCarriers';

import { Button, Text } from '@/components/v4';
import AGGridMain from 'components/tables/AGGrid/AGGridMain';
import useColumnState from '../../../hooks/useColumnState';

import { getCarriersTableColumns } from './carriersTableConfig';

export default function Carriers() {
    const gridRef = useRef();
    const navigate = useNavigate();

    const { darkMode } = useSelector((state) => state.settings);

    const [tableData, setTableData] = useState({
        columns: [],
        data: [],
    });

    const handleEditCarrier = useCallback(
        (carrierData) => {
            navigate(`/carriers/edit/${carrierData.id}`);
        },
        [navigate],
    );

    const handleAddCarrier = () => {
        navigate('/carriers/add');
    };

    const baseColumns = useMemo(
        () =>
            getCarriersTableColumns({
                darkMode,
                onEditCarrier: handleEditCarrier,
            }),
        [darkMode, handleEditCarrier],
    );

    const { columns, onColumnVisible } = useColumnState(baseColumns);

    const tableDataWithColumns = useMemo(
        () => ({
            columns,
            data: tableData.data,
        }),
        [columns, tableData.data],
    );

    const { refetch, isRefetching, isFetching } = useGetCarriers(
        setTableData,
        gridRef,
        baseColumns,
    );

    const titleName = 'Carriers';

    return (
        <>
            <HStack justifyContent="space-between" marginBottom={5}>
                <Text sx={{ fontSize: '20', fontWeight: '500' }}>Carriers</Text>
            </HStack>

            <AGGridMain
                gridRef={gridRef}
                tableData={tableDataWithColumns}
                isFetching={isFetching}
                isRefetching={isRefetching}
                titleName={titleName}
                refetch={refetch}
                onColumnVisible={onColumnVisible}
                extraComponents={
                    <HStack pl={5} spacing={2}>
                        <Button
                            leftIcon={<AddIcon />}
                            onClick={handleAddCarrier}
                            size="sm"
                            padding="6px 12px">
                            Add Carrier
                        </Button>
                    </HStack>
                }
            />
        </>
    );
}
